// src/components/settings/POSCheckoutSettingsCard.jsx
import React, { useState } from 'react';
import { CreditCard, Settings2 } from 'lucide-react';
import CashRemarkCategoryDialog from './CashRemarkCategoryDialog';

// PC收银台(店员在店里实际操作的收银台)的结账方式开关——和上面 PaymentSettingsCard
// 管的"H5在线商城支付方式"(KHQR/支付宝/USDT/货到付款)是两码事，不要混淆：
// 这里控制的是店员收银时，屏幕右侧能选哪几种付款方式
const CHECKOUT_METHODS = [
  { field: 'pos_enable_cash',   label: '现金' },
  { field: 'pos_enable_card',   label: '刷卡' },
  { field: 'pos_enable_mobile', label: '移动支付（KHQR）' },
  { field: 'pos_enable_credit', label: '记账未收款' },
];

const POSCheckoutSettingsCard = ({ settings, onToggle }) => {
  const [showCategoryDialog, setShowCategoryDialog] = useState(false);

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <div className="flex items-center gap-2 mb-1">
        <CreditCard className="w-5 h-5 text-blue-600" />
        <h3 className="font-semibold">收银台结账方式</h3>
      </div>
      <p className="text-xs text-gray-400 mb-4">
        控制PC收银台结账时能选哪几种付款方式（和上面H5在线商城的支付方式是分开设置的）
      </p>
      <div className="space-y-3">
        {CHECKOUT_METHODS.map(m => (
          <label key={m.field} className="flex items-center justify-between cursor-pointer">
            <span className="text-sm text-gray-700">{m.label}</span>
            <input type="checkbox"
              checked={!!settings[m.field]}
              onChange={() => onToggle(m.field)}
              className="w-4 h-4 rounded" />
          </label>
        ))}
      </div>

      {/* 现金备注分类——轻量维护，弹窗管理，不单独占导航入口 */}
      <button onClick={() => setShowCategoryDialog(true)}
        className="w-full mt-4 pt-4 border-t border-gray-100 flex items-center justify-center gap-1.5 text-sm text-blue-600 hover:text-blue-700">
        <Settings2 className="w-4 h-4" />管理现金收款备注分类
      </button>

      <p className="text-xs text-amber-600 mt-3">
        ⚠️ "记账未收款"默认关闭——开启前，建议先去"记账客户管理"里维护好可以被赊账的客户名单
      </p>

      {showCategoryDialog && (
        <CashRemarkCategoryDialog onClose={() => setShowCategoryDialog(false)} />
      )}
    </div>
  );
};

export default POSCheckoutSettingsCard;